import { UnitTransferSignatureDocumentTypeEnumType } from '__generated__/graphql';

export default function unitTransferSignatureDocumentTypeToReadable(
  type: UnitTransferSignatureDocumentTypeEnumType
): string {
  switch (type) {
    case UnitTransferSignatureDocumentTypeEnumType.PersonalInformationSheetTransferee:
      return 'Personal Information Sheet (Transferee)';
    case UnitTransferSignatureDocumentTypeEnumType.PersonalInformationSheetTransferor:
      return 'Personal Information Sheet (Transferor)';
    case UnitTransferSignatureDocumentTypeEnumType.RequestLetter:
      return 'Request Letter';
    case UnitTransferSignatureDocumentTypeEnumType.ImConsentLetter:
      return 'IM Consent Letter';
    case UnitTransferSignatureDocumentTypeEnumType.DeedOfAdherence:
      return 'Deed of Adherence';
    case UnitTransferSignatureDocumentTypeEnumType.IntimationLetter:
      return 'Intimation Letter';
    default:
      return type;
  }
}
